const defaultLicense = {
  academia: '',
  activa: true,
  afiliaciones: true,
  clases_vivo: true,
  comisiones: 0,
  control_alumnos: true,
  evaluaciones: true,
  fecha_alta: '',
  id: '',
  importacion_alumnos: true,
  integraciones: true,
  maximo_administradores: 10000,
  maximo_alumnos: 20000,
  maximo_emails: 10000,
  maximo_instructores: 10000,
  maximo_mapas: 1000,
  maximo_productos: 1000,
  maximo_profesores: 10000,
  maximo_proyectos: 1000,
  maximo_puntos_venta: 1000,
  tipo_universidad: 0,
  usuario: '',
  venta: ''
}

export default defaultLicense
